import state from './moduleOrganizationState.js';
import mutations from './moduleOrganizationMutation.js';
import actions from './moduleOrganizationActions.js';
import getters from './moduleOrganizationGetters.js';

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
};
